// Google Analytics Configuration for My English Gurukul
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

// Enhanced analytics configuration
export const ANALYTICS_CONFIG = {
    measurementId: GA_MEASUREMENT_ID,
    // Enhanced ecommerce for tracking learning progress
    send_page_view: true,
    custom_map: {
        custom_parameter: 'dimension1'
    }
};

// Analytics Events for English Learning App
export const ANALYTICS_EVENTS = {
    // Page Views
    PAGE_VIEW: 'page_view',

    // User Actions
    USER_SIGNUP: 'sign_up',
    USER_LOGIN: 'login',
    USER_LOGOUT: 'logout',
    LANGUAGE_CHANGED: 'language_change',

    // Learning Events
    GRAMMAR_LESSON_START: 'grammar_lesson_start',
    GRAMMAR_LESSON_COMPLETE: 'grammar_lesson_complete',
    SENTENCE_PRACTICE_START: 'sentence_practice_start',
    SENTENCE_PRACTICE_COMPLETE: 'sentence_practice_complete',
    WORD_MEMORIZED: 'word_memorized',
    QUIZ_COMPLETED: 'quiz_completed',

    // Engagement Events
    SEARCH_PERFORMED: 'search',
    FAVORITE_ADDED: 'favorite_added',
    PROGRESS_MILESTONE: 'progress_milestone',

    // AI Features
    GRAMMAR_CHECK_USED: 'grammar_check_used',
    TRANSLATION_USED: 'translation_used',

    // Errors
    API_ERROR: 'api_error',
    LOADING_ERROR: 'loading_error'
};

// User Properties for Segmentation
export const USER_PROPERTIES = {
    SELECTED_LANGUAGE: 'selected_language',
    USER_LEVEL: 'user_level',
    SIGNUP_METHOD: 'signup_method',
    DEVICE_TYPE: 'device_type'
};

// Custom Dimensions for Enhanced Tracking
export const CUSTOM_DIMENSIONS = {
    LESSON_TYPE: 'lesson_type',
    DIFFICULTY_LEVEL: 'difficulty_level',
    COMPLETION_RATE: 'completion_rate',
    SESSION_DURATION: 'session_duration'
}; 